<div class="reset-password-container">
  <div class="card">
    <div class="card-header text-center">
      <h2>Reset Password</h2>
    </div>
    <div class="card-body">
      <!-- Success Message -->
      <div *ngIf="showSuccess" class="alert alert-success">
        <i class="bi bi-check-circle-fill me-2"></i>
        Your password has been reset successfully.
      </div>

      <!-- Error Message -->
      <div *ngIf="showError" class="alert alert-danger">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        <span [innerHTML]="errorMessage"></span>
      </div>

      <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
        <!-- New Password -->
        <div class="form-group">
          <div class="label-container">
            <label for="password">New Password</label>
            <label class="password-visibility float-end">
              <button class="btn-password-visibility" type="button" (click)="togglePasswordTextType()">
                <span class="password-label">{{passwordTypeText ? 'Hide ' : 'Show '}}</span>
                <img [src]="getVisibilityIcon(passwordTypeText)" width="18" height="18" style="margin-right: 4px;">
              </button>
            </label>
          </div>
          <div class="input-group">
            <input
              [type]="passwordTypeText ? 'text' : 'password'"
              id="password"
              formControlName="password"
              class="form-control"
              [ngClass]="{'is-invalid': resetPasswordForm.get('password')?.invalid && resetPasswordForm.get('password')?.touched}"
              autocomplete="new-password"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Password must be at least 8 characters with uppercase, lowercase, number, and special character. No spaces allowed."
            />
          </div>
          <div class="validation-message" *ngIf="resetPasswordForm.get('password')?.touched">
            <div *ngIf="hasError('password', 'required')">
              New password is required
            </div>
            <div *ngIf="!hasError('password', 'required') && hasError('password', 'minlength')">
              Password must be at least 8 characters
            </div>
            <div *ngIf="!hasError('password', 'required') && !hasError('password', 'minlength') && hasError('password', 'pattern')">
              Password must contain uppercase letters, lowercase letters, numbers, and special characters
            </div>
            <div *ngIf="!hasError('password', 'required') && !hasError('password', 'minlength') && !hasError('password', 'pattern') && hasError('password', 'containsSpaces')">
              Password cannot contain spaces
            </div>
          </div>
        </div>

        <!-- Confirm Password -->
        <div class="form-group mb-3">
          <div class="label-container">
            <label for="confirmPassword">Confirm Password</label>
            <label class="password-visibility float-end">
              <button class="btn-password-visibility" type="button" (click)="toggleConfirmPasswordTextType()">
                <span class="password-label">{{confirmPasswordTypeText ? 'Hide ' : 'Show '}}</span>
                <img [src]="getVisibilityIcon(confirmPasswordTypeText)" width="18" height="18" style="margin-right: 4px;">
              </button>
            </label>
          </div>
          <div class="input-group">
            <input
              [type]="confirmPasswordTypeText ? 'text' : 'password'"
              id="confirmPassword"
              formControlName="confirmPassword"
              class="form-control"
              [ngClass]="{'is-invalid': resetPasswordForm.get('confirmPassword')?.invalid && resetPasswordForm.get('confirmPassword')?.touched}"
              autocomplete="new-password"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Re-enter your new password to confirm"
            />
          </div>
          <div class="validation-message" *ngIf="resetPasswordForm.get('confirmPassword')?.touched">
            <div *ngIf="hasError('confirmPassword', 'required')">
              Please confirm your new password
            </div>
            <div *ngIf="!hasError('confirmPassword', 'required') && hasError('confirmPassword', 'mismatch')">
              Passwords do not match
            </div>
            <div *ngIf="!hasError('confirmPassword', 'required') && !hasError('confirmPassword', 'mismatch') && hasError('confirmPassword', 'containsSpaces')">
              Password cannot contain spaces
            </div>
          </div>
        </div>

        <!-- Password Requirements -->
        <div class="password-requirements">
          <h6>Password Requirements</h6>
          <div class="row g-2">
            <div class="col-md-6">
              <div [ngClass]="{'text-success': hasMinLength()}">
                <i class="bi" [ngClass]="hasMinLength() ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                At least 8 characters
              </div>
              <div [ngClass]="{'text-success': hasUpperCase()}">
                <i class="bi" [ngClass]="hasUpperCase() ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                One uppercase letter
              </div>
              <div [ngClass]="{'text-success': hasLowerCase()}">
                <i class="bi" [ngClass]="hasLowerCase() ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                One lowercase letter
              </div>
            </div>
            <div class="col-md-6">
              <div [ngClass]="{'text-success': hasNumber()}">
                <i class="bi" [ngClass]="hasNumber() ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                One number
              </div>
              <div [ngClass]="{'text-success': hasSpecialChar()}">
                <i class="bi" [ngClass]="hasSpecialChar() ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                One special character
              </div>
              <div [ngClass]="{'text-success': !hasError('confirmPassword', 'mismatch') && resetPasswordForm.get('confirmPassword')?.value}">
                <i class="bi" [ngClass]="!hasError('confirmPassword', 'mismatch') && resetPasswordForm.get('confirmPassword')?.value ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                Passwords match
              </div>
            </div>
          </div>
        </div>

        <!-- Turnstile CAPTCHA -->
        <div class="form-group">
          <app-turnstile
            [siteKey]="siteKey"
            (tokenChange)="onTurnstileToken($event)"
            #turnstileWidget
          ></app-turnstile>
        </div>

        <div class="form-group text-center button-container">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="resetPasswordForm.invalid || isLoading || !turnstileToken"
          >
            {{ isLoading ? 'Resetting...' : 'Reset Password' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
